import styles from "./IconButton.module.css";
import PropTypes from "prop-types";

/**
 * A clickable icon/text pair. Used as a base for AddButton and UndoButton.
 */
export function IconButton({ icon, onClick, children, ...props }) {
  return (
    <button className={styles.button} {...props} onClick={onClick}>
      <div className={styles.icon}>{icon}</div>
      <span className={styles.label}>{children || "Add"}</span>
    </button>
  );
}

IconButton.propTypes = {
  /**
   * Icon element. Should be 20x20 to fit the style.
   */
  icon: PropTypes.element,

  /**
   * Callback to run when the user clicks the button.
   */
  onClick: PropTypes.func.isRequired,
};
